/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgMessageAlt = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <style>{'.ico-message-alt_svg__st0{fill:currentcolor}'}</style>
    <path className="ico-message-alt_svg__st0" d="M15 9h2v2h-2zm-4 0h2v2h-2zM7 9h2v2H7z" />
    <path
      className="ico-message-alt_svg__st0"
      d="M2 2v20h3.5l3-4H22V2H2zm18 14H7.5l-3 4H4V4h16v12z"
    />
  </Icon>
);
export { SvgMessageAlt as MessageAlt };
